import * as React from "react";

export const Loader = () => {
    return (
        <div className={'loader loader-fullscreen'}>
            <div className="loader-icon">
                <div className="outer"/>
                <div className="middle"/>
                <div className="inner"/>
            </div>

            <span className={'loader-text'}>Loading...</span>
        </div>
    )
};